import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ADMIN_PIN = "2026";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [showPinModal, setShowPinModal] = useState(false);
  const [pin, setPin] = useState("");
  const [pinError, setPinError] = useState("");
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleAdminClick = (e) => {
    e.preventDefault();
    setShowPinModal(true);
    setPin("");
    setPinError("");
  };

  const handlePinSubmit = (e) => {
    e.preventDefault();
    if (pin === ADMIN_PIN) {
      setShowPinModal(false);
      setPin("");
      setPinError("");
      navigate("/login");
    } else {
      setPinError("Code incorrect");
      setPin("");
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuLinkClick = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
  };

  const onSearchSubmit = (e) => {
    e.preventDefault();
    const query = search.trim();
    if (query) {
      // Recherche avec terme
      const url = `/produits?search=${encodeURIComponent(query)}`;
      navigate(url);
    } else {
      // Recherche vide = afficher tous les produits
      navigate('/produits');
    }
    setIsMenuOpen(false);
  };

  const clearSearch = () => {
    setSearch('');
    navigate('/produits');
    setIsMenuOpen(false);
  };

  return (
    <>
    <div style={{
      background: '#0a1628',
      color: '#54ba66',
      fontSize: '0.85rem',
      padding: '6px 0',
      borderBottom: '1px solid rgba(84,186,102,0.15)',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 1001
    }}>
      <div className="container" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px'
      }}>
        <div style={{ display: 'flex', gap: '30px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span>
            <i className="fas fa-phone-alt" style={{ marginRight: 6 }}></i>
            05 22 34 06 59
          </span>
          <a href="https://www.linkedin.com/company/domoelecsarl/" target="_blank" rel="noopener noreferrer" style={{ color: '#54ba66', textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <i className="fab fa-linkedin" style={{ marginRight: 6 }}></i>
            DOMOELEC
          </a>
        </div>
        <button onClick={handleAdminClick} style={{
          color: '#54ba66',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontWeight: 500,
          fontSize: '0.85rem',
          padding: 0
        }}>
          <i className="fas fa-user-shield"></i>
          Espace Admin
        </button>
      </div>
    </div>
    <header className="header-modern">
      <nav className="navbar-modern">
        <div className="nav-inner">
          <div className="brand">
            <Link to="/" className="brand-link">
              <img src="/images/LOGO.png" alt="DOMOELEC" />
              
            </Link>
          </div>

          {/* Barre de recherche produits */}
          <form className="nav-search-modern" onSubmit={onSearchSubmit} role="search" aria-label="Rechercher des produits">
            <i className="fas fa-search"></i>
            <input
              type="search"
              placeholder="Rechercher un produit ou une référence..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              aria-label="Rechercher un produit ou une référence"
            />
            {search && (
              <button 
                type="button" 
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  clearSearch();
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                className="clear-search-btn"
                aria-label="Effacer la recherche"
                title="Effacer la recherche"
              >
                ×
              </button>
            )}
            <button type="submit">Rechercher</button>
          </form>

          <button className="hamburger" onClick={toggleMenu} aria-label="Menu">
            <span></span><span></span><span></span>
          </button>

          <div className={`nav-center ${isMenuOpen ? 'open' : ''}`}>
            <Link to="/" className="nav-item-modern" onClick={handleMenuLinkClick}>Accueil</Link>
            <Link to="/domoelec" className="nav-item-modern" onClick={handleMenuLinkClick}>DOMOELEC</Link>
            <Link to="/produits" className="nav-item-modern" onClick={handleMenuLinkClick}>Produits</Link>
            <Link to="/services" className="nav-item-modern" onClick={handleMenuLinkClick}>Services</Link>
            <Link to="/contact" className="nav-item-modern" onClick={handleMenuLinkClick}>Contact</Link>
          </div>

          <div className={`nav-actions ${isMenuOpen ? 'open' : ''}`}>
            {isAuthenticated ? (
              <>
             
             
              </>
            ) : (
              <>
      
              </>
            )}
          </div>
        </div>
      </nav>
    </header>

    {showPinModal && (
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000
      }} onClick={() => setShowPinModal(false)}>
        <div style={{
          background: '#fff',
          borderRadius: 12,
          padding: '36px 32px',
          width: '100%',
          maxWidth: 340,
          textAlign: 'center',
          boxShadow: '0 4px 24px rgba(0,0,0,0.12)'
        }} onClick={(e) => e.stopPropagation()}>
          <i className="fas fa-lock" style={{ fontSize: 28, color: '#1a1a1a', marginBottom: 16 }}></i>
          <h3 style={{ margin: '0 0 6px', fontSize: 18, fontWeight: 600, color: '#1a1a1a' }}>Espace Admin</h3>
          <p style={{ margin: '0 0 24px', fontSize: 13, color: '#888' }}>Saisissez le code PIN pour continuer</p>
          <form onSubmit={handlePinSubmit}>
            <input
              type="password"
              value={pin}
              onChange={(e) => { setPin(e.target.value); setPinError(""); }}
              placeholder="Code PIN"
              maxLength={6}
              autoFocus
              style={{
                width: '100%',
                padding: '12px 14px',
                border: pinError ? '1px solid #ef4444' : '1px solid #ddd',
                borderRadius: 8,
                fontSize: 18,
                textAlign: 'center',
                letterSpacing: 8,
                boxSizing: 'border-box',
                outline: 'none'
              }}
            />
            {pinError && (
              <p style={{ color: '#ef4444', fontSize: 13, margin: '8px 0 0' }}>{pinError}</p>
            )}
            <button type="submit" style={{
              width: '100%',
              marginTop: 16,
              padding: '10px',
              background: '#1a1a1a',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer'
            }}>
              Valider
            </button>
          </form>
          <button onClick={() => setShowPinModal(false)} style={{
            marginTop: 12,
            background: 'none',
            border: 'none',
            color: '#888',
            fontSize: 13,
            cursor: 'pointer'
          }}>
            Annuler
          </button>
        </div>
      </div>
    )}
    </>
  );
};

export default Header;
